import { render, staticRenderFns } from "./Fork.vue?vue&type=template&id=3b86342a&"
import script from "./Fork.vue?vue&type=script&lang=js&"
export * from "./Fork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports